import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
//import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import Course from "./Course";
import { pdf } from "@react-pdf/renderer";
import Convocation_Guest_List_Report from "./Document/Convocation_Guest_List_Report";

const ConvocationGuest = () => {

    const [course, setCourse] = useState([])
    const [vendordata, setVendorData] = useState([])
    const [courseid, setCourseid] = useState('')




    const [value, setValue] = useState({
        Course_Id: '',
    })

    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    useEffect(() => {
        getCourseData()
    }, [])

    const [pdfdata, setpdfData] = useState([]);

    async function getDetails() {
        const param = {
            Course_Id: value.Course_Id,
            StartYear: value.year,
            EndYear: value.toyears
        };

        axios.post(`${BASE_URL}/getconvocationguestlist`, param).then((res) => {
            if (res.data.length === 0) {
                alert("No record found");
                return; // stop further execution
            }

            setpdfData(res.data);
            convocationguestreport(res.data);
        }).catch((err) => {
            console.error("Error fetching data:", err);
            alert("Something went wrong while fetching the data.");
        });
    }



    const convocationguestreport = async (data) => {
        const blob = await pdf(<Convocation_Guest_List_Report data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };



    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const roledata = {
        role: Cookies.get(`role`),
        pageid: 53,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);

    return (

        <div class="container-fluid page-body-wrapper">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Convocation Guest List Report</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3">
                                        <div class='row'>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Year<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.year} onChange={onhandleChange} name='year'>
                                                    <option value="">Select Year</option>
                                                    <option>2024</option>
                                                    <option>2023</option>
                                                    <option>2022</option>
                                                    <option>2021</option>
                                                    <option>2020</option>
                                                    <option>2019</option>
                                                    <option>2018</option>
                                                    <option>2017</option>
                                                    <option>2016</option>
                                                    <option>2015</option>
                                                    <option>2014</option>
                                                    <option>2013</option>
                                                    <option>2012</option>
                                                    <option>2011</option>
                                                    <option>2010</option>
                                                    <option>2009</option>
                                                    <option>2008</option>
                                                    <option>2007</option>
                                                    <option>2006</option>
                                                    <option>2005</option>
                                                    <option>2004</option>
                                                    <option>2003</option>
                                                    <option>2002</option>
                                                    <option>2001</option><option>2000</option>
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label htmlFor="toyears">To Year<span className='text-danger'>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="toyears"
                                                    name="toyears"
                                                    value={value.toyears}
                                                    maxLength={4} // just in case
                                                    onKeyDown={(e) => { 
                                                        // Allow: Backspace, Delete, Arrow keys, Tab
                                                        if (
                                                            ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
                                                        ) return;

                                                        // Block if not a digit
                                                        if (!/[0-9]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        // Extra safety: accept only digits and max 4
                                                        const input = e.target.value;
                                                        if (/^\d{0,4}$/.test(input)) {
                                                            setValue((prev) => ({ ...prev, toyears: input }));
                                                        }
                                                    }}
                                                    placeholder="e.g. 2024"
                                                />
                                            </div>




                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option>Select Course</option>
                                                    {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                           )
                                                    })}
                                                </select>
                                            </div>


                                        </div>


                                        <button
                                            type="button"
                                            onClick={getDetails}
                                            class="btn btn-primary mr-2"
                                            disabled={
                                                !value.Course_Id ||
                                                value.Course_Id === "Select Course" ||
                                                !value.year ||
                                                !value.toyears
                                            }>
                                            Show
                                        </button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-primary mr-2">Back</button>



                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default ConvocationGuest
